import { render, staticRenderFns } from "./IconAudio.vue?vue&type=template&id=28d10235&"
import script from "./IconAudio.vue?vue&type=script&lang=js&"
export * from "./IconAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports